import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import ManifestTotal from '../ManifestTotal';

export default function CartonGuidesHeader(
  {
    totalGuides,
    totalScans,
    totalGuidesFree,
    totalScansFree,
    totalGuidesExcept,
    totalScansExcept,
    concludeClassificationUrl
  }
) {
  const csrfToken = Cookies.get('csrftoken');

  return (
    <>
      {/* First Row */}
      <div className="row no-gutters align-items-center">
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('total of guides')}
            total={totalGuides}
          />
        </div>
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('scans')}
            total={totalScans}
          />
        </div>
        <form
          method="GET"
          action={concludeClassificationUrl}
          className="col-sm-4 text-center text-sm-right pt-3 pt-sm-0"
        >
          <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
          <button type="submit" className="btn btn-primary">
            <i className="fas fa-check mr-2" />
            {gettext('end classification')}
          </button>
        </form>
      </div>

      {/* Second Row */}
      <div className="row mt-3">
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('total de guias libre')}
            total={totalGuidesFree}
          />
        </div>
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('guias libres escaneadas')}
            total={totalScansFree}
          />
        </div>
      </div>

      {/* Third Row */}
      <div className="row mt-3">
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('total de guias con excepcion')}
            total={totalGuidesExcept}
          />
        </div>
        <div className="col-sm-4">
          <ManifestTotal
            title={gettext('guias con excepcion escaneadas')}
            total={totalScansExcept}
          />
        </div>
      </div>
    </>
  );
}

CartonGuidesHeader.propTypes = {
  totalGuides: PropTypes.number.isRequired,
  totalScans: PropTypes.number.isRequired,
  concludeClassificationUrl: PropTypes.string.isRequired
};
